import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import { useTheme } from '@mui/material/styles';
// import { useRouter } from 'next/router';
import { Box } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './styles';

const { publicRuntimeConfig } = getConfig();
let savedPass = '';

const ActionModalFields = ({
  emailAddress,
  setemailAddress,
  userPassword,
  setUserPassword,
  loginError,
  isApiError,
  setDisablecta,
  onLoadingDisablecta,
  handleLoginButtonThroughPass,
  setLoginError,
  invalidText,
  handleOnChange,
  recaptchaRef,
  setUserValue,
}) => {
  const theme = useTheme();
  // const router = useRouter();
  // const [loginError, setLoginError] = useState(false);
  // const [LoginErrorText, setLoginErrorText] = useState('');
  // const [emailAddress, setemailAddress] = useState('');
  // const [unknownEmail, setUnknownEmail] = useState('');
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  const [enableSubmit, setEnableSubmit] = useState(false);
  // const [enableLogin, setEnableLogin] = useState(false);
  // eslint-disable-next-line
  const validEmailAddress = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
  const validPassword = /^.{6,}$/;
  // eslint-disable-next-line

  function validateEmail(email) {
    if (validEmailAddress.test(email)) {
      setEnableSubmit(true);
      return true;
    }
    setEnableSubmit(false);
    return false;
  }

  function handleEmailAddress(event) {
    const email = event.target.value;
    setemailAddress(email);
    setUserValue(email);
  }
  useEffect(() => {
    if (emailAddress.length !== 0 || userPassword.length !== 0) {
      if (validateEmail(emailAddress) && validPassword.test(userPassword)) {
        setDisablecta(false);
        const input = document.getElementById('input-text-id');
        if (input !== null && input !== undefined) {
          input.addEventListener('keyup', event => {
            if (event.key === 'Enter') {
              if (userPassword === savedPass) {
                handleLoginButtonThroughPass();
              }
            }
          });
        }
      } else {
        setDisablecta(true);
      }
    } else {
      setLoginError('');
      setDisablecta(true);
    }
  }, [emailAddress, userPassword]);

  const handlePasswordVisibility = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  // const onForgotPassword = () => {
  //   router.push(`${publicRuntimeConfig.NEXT_PUBLIC_MYEIR}/forgot-password?isAcquisition=${true}`);
  // };

  // function handleLoginPassword() {
  //   props.handlePasswordSubmission(userPassword);
  //   // console.log("Login button clicked");
  // }

  function handleUserPassword(event) {
    const password = event.target.value;
    savedPass = password;
    setUserPassword(password);
  }

  let emailTextFieldStyle = 'input-text';

  if (!emailAddress) {
    emailTextFieldStyle += ' text-empty';
  } else if (enableSubmit) {
    emailTextFieldStyle += onLoadingDisablecta ? ' text-empty' : ' text-entered';
  } else {
    emailTextFieldStyle += ' text-entered-invalid';
  }

  let passwordTextFieldStyle = 'input-text';

  if (!userPassword) {
    passwordTextFieldStyle += ' text-empty';
  } else if (userPassword) {
    passwordTextFieldStyle += onLoadingDisablecta ? ' text-empty' : ' text-entered';
  } else {
    passwordTextFieldStyle += ' text-entered-invalid';
  }

  return (
    <Box>
      <Box sx={styles(theme).bodyContainer}>
        <div className='text-field'>
          <input
            className={emailTextFieldStyle}
            // className={`input-text${
            //   !emailAddress ? ' text-empty' : enableSubmit ? ' text-entered' : ' text-entered-invalid'
            // }`}
            type='email'
            id='email'
            autoComplete='On'
            placeholder='Enter username'
            value={emailAddress}
            onChange={handleEmailAddress}
            disabled={onLoadingDisablecta}
          />
          {/* {unknownEmail && <div className='username-not-found'>console.error();</div>}
        {unknownEmail && <div className="username-not-found">Username not found</div>} */}
          {!enableSubmit && emailAddress !== '' && (
            <div className='invalid-email-format'>Please enter a valid email ID</div>
          )}
          {isApiError ? <div className='invalid-email-format'>{loginError}</div> : ' '}
        </div>
        <div className='text-field'>
          <input
            className={passwordTextFieldStyle}
            id='input-text-id'
            // className={`input-text visibility-icon-padding${
            //   !userPassword ? ' text-empty' : userPassword ? ' text-entered' : ' text-entered-invalid'
            // }`}
            type={passwordVisibility ? 'text' : 'password'}
            placeholder='Enter password'
            autoComplete='On'
            value={userPassword}
            onChange={handleUserPassword}
            disabled={onLoadingDisablecta}
          />
          {/* {passwordVisibility ? (
            <VisibilityOffIcon
              role='button'
              className={`${onLoadingDisablecta ? 'visibility-disable' : 'visibility-off'}`}
              onClick={handlePasswordVisibility}
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handlePasswordVisibility();
                }
              }}
            />
          ) : (
            <VisibilityIcon
              role='button'
              className={`${onLoadingDisablecta ? 'visibility-disable' : 'visibility-on'}`}
              onClick={handlePasswordVisibility}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handlePasswordVisibility();
                }
              }}
              tabIndex={0}
            />
          )} */}
          <span
            role='button'
            tabIndex={0}
            aria-label={passwordVisibility ? 'Hide password' : 'Show password'}
            className={`${onLoadingDisablecta ? 'visibility-disable' : 'visibility-on'}`}
            onClick={handlePasswordVisibility}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handlePasswordVisibility();
              }
            }}
          >
            {passwordVisibility ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </span>

          {/* {!loginError && ( */}
          {/* <div
            className={`${
              onLoadingDisablecta ? 'disabled-forgotten-input-text' : 'forgotten-input-text'
            }`}
          > */}
          <a
            className={`${
              onLoadingDisablecta ? 'disabled-forgotten-input-text' : 'forgotten-input-text'
            }`}
            href={`${publicRuntimeConfig.NEXT_PUBLIC_MYEIR}/forgot-password?isAcquisition=${true}`}
          >
            Forgotten your password?
          </a>
          {/* </div> */}
          {/* )} */}
        </div>
      </Box>
      <Box sx={styles(theme).mainContainer}>
        {/* Recaptcha v2 incase v3 failed */}
        {invalidText === 'Invalid reCAPTCHA!' && (
          <div className={styles(theme).reCaptchaError}>
            <div className={styles(theme).reCaptcha}>
              <ReCAPTCHA
                ref={recaptchaRef}
                className='reCaptchaRobot'
                sitekey='6LfZsRYTAAAAAJMBqawqK3sy7NmHDC8M9rKdkX36'
                render='explicit'
                onChange={handleOnChange}
              />
            </div>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default ActionModalFields;
